var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalCaptado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 16.5C29.1 11.6 32.1 7.59998 32.5 7.09998C33.2 5.99998 34.5 3.99998 32.5 3.99998C30.5 3.99998 28.2 5.49998 26.7 3.99998C24.2 1.39998 22.9 1.39998 21.2 3.79998C20.2 5.19998 18.6 5.19998 16.6 5.19998C12.4 5.19998 13.3 6.89998 14.6 8.09998C15.2 8.69998 18.9 11.8 18.4 16.9C11.8 18.4 5 26.8 5 34.1C5 43.5 10.3 46 25 46C39.7 46 45 43.5 45 34.1C45 26.2 37.8 18.6 30.4 16.5Z",
    stroke: "#4B5055",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6001 6.10002C15.9001 10.1 18.8001 10.9 20.4001 9.40002C22.2001 7.70002 23.2001 6.90002 25.1001 9.30002C26.1001 10.5 27.8001 10.1 29.0001 9.00002C31.2001 7.00002 33.1001 6.20002 32.9001 4.90002M18.3001 16.7C18.3001 16.7 23.7001 20 30.4001 16.3C32.5001 15.1 36.4001 11.2 41.5001 14M30.4001 16.3C32.1001 15.6 37.0001 14.3 40.5001 18",
    stroke: "#4B5055",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9 35.6C29.9 32.6 27.5 31.8 25.1 31.2C23.2 30.7 21.4 30.3 21.4 28.4C21.4 27.6 21.7 25.8 24.4 25.8C26.3 25.8 27.2 27 27.5 28.4H29.3C28.8 26.4 27.9 24.6 25.3 24.1V22H23.5V24C22 24.2 19.4 25.4 19.4 28.6C19.4 34.4 27.8 31.4 27.8 35.8C27.8 37.3 27.1 38.6 24.4 38.6C21.6 38.6 20.8 36.4 20.8 35.2H19C19.3 39.1 22 40 23.5 40.3V42H25.3V40.3C26.7 40.2 29.9 39.2 29.9 35.6Z",
    fill: "#4B5055"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalCaptado);
export default __webpack_public_path__ + "static/media/totalCaptado.d224ff1c953940e8979f9a29b44824bd.svg";
export { ForwardRef as ReactComponent };